import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { finalize, Observable } from 'rxjs';

import { StaffingUnit } from '@shared/models';

import { BaseService } from '../base.service';
import { httpParams } from '../http-params.builder';
import { LoadersService } from '../loaders.service';

@Injectable({
  providedIn: 'root',
})
export class StaffingUnitService extends BaseService {
  constructor(
    private http: HttpClient,
    private loadersService: LoadersService
  ) {
    super();
  }

  getAll(loader: string, weeks?: string[]): Observable<StaffingUnit[]> {
    this.loadersService.show(loader);
    const url = `${this.baseUrl}/staffing-units`;
    return this.http
      .get<StaffingUnit[]>(url, { params: httpParams().array('weeks', weeks).build() })
      .pipe(finalize(() => this.loadersService.hide(loader)));
  }

  getByUser(loader: string, userId: string): Observable<StaffingUnit[]> {
    this.loadersService.show(loader);
    const url = `${this.baseUrl}/staffing-units/user/${userId}`;
    return this.http.get<StaffingUnit[]>(url).pipe(finalize(() => this.loadersService.hide(loader)));
  }

  edit(
    loader: string,
    staffingUnits: StaffingUnit[],
    staffingUnitIdsToDelete: string[],
    assignedEmployeesToRemove: { staffingUnitId: string; week: string; userId: string }[],
    weeks?: string[]
  ): Observable<StaffingUnit[]> {
    this.loadersService.show(loader);
    return this.http
      .put<
        StaffingUnit[]
      >(this.baseUrl + '/staffing-units', { staffingUnits: staffingUnits, staffingUnitIdsToDelete: staffingUnitIdsToDelete, assignedEmployeesToRemove: assignedEmployeesToRemove }, { params: httpParams().array('weeks', weeks).build() })
      .pipe(finalize(() => this.loadersService.hide(loader)));
  }
}
